
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {BankaHesabiEntity} from "@/entity/BankaHesabiEntity";
import BankaHesabiForm from "@/components/forms/BankaHesabiForm.vue";
import XmlHesapEkle from "@/components/forms/XmlHesapEkle.vue";
import {VekaletEntity} from "@/entity/VekaletEntity";
import {KisiEntity} from "@/entity/KisiEntity";
import {KurumEntity} from "@/entity/KurumEntity";
import {BankaHesabiSahibi, BankaHesabiSahibiLabel} from "@/enum/BankaHesabiSahibi";
import {BuroEntity} from "@/entity/BuroEntity";
import {AvukatEntity} from "@/entity/AvukatEntity";

@Component({
  components: {BankaHesabiForm, DeleteDialog, FormDialog, XmlHesapEkle}
})
export default class XmlBankaHesabiSec extends Vue {

  @Prop() editable!: boolean;
  @Prop() action!: string;
  @Prop() vekalet!: any;
  @Prop()height!:string
  @Prop({default:{'items-per-page-options': [3,2]}})footerProps!:any
  selected: Array<any> = [];
  bankaHesaplari: Array<BankaHesabiEntity> = [];
  burolar: Array<number> = [];
  bankaHesabiSahibiLabel:any = BankaHesabiSahibiLabel;

  headers = [
    {text: 'Hesap Sahibi', value: 'varsayilan_banka_hesabi_sahibi', width: '80px'},
    {text: 'Hesap Adı', value: 'banka_hesap_ismi'},
    {text: 'Banka Adı', value: 'banka_adi'},
    {text: 'Iban', value: 'iban'},
    {text: 'Hesap No', value: 'hesap_numarasi'},
    {text: 'Para Birimi', value: 'kisa_isim', align: 'center'},

  ]

  @Watch("vekalet.varsayilan_banka_hesabi_id")
  onBankaHesabiChange() {
    if (this.selected.length === 0) {
      this.selected = [this.vekalet.varsayilan_banka_hesabi];
    }
  }

  //İLK GİRİLEN BANKA HESABININ VARSAYILAN GELMESİ
  @Watch("vekalet.varsayilan_banka_hesabi")
  onVekaletChange() {
    this.bankaHesaplariDoldur();

    // Clear the selection array first to avoid duplicates
    this.selected = [];

    if (this.bankaHesaplari.length > 0) {
      if (!this.vekalet.varsayilan_banka_hesabi) {
        // Sadece banka hesapları varsa ve vekalet bilgileri mevcutsa işlem yap
        if (this.vekalet.vekalet_bilgileri && this.vekalet.vekalet_bilgileri.id) {
          this.vekalet.varsayilan_banka_hesabi_id = this.bankaHesaplari[0].banka_hesap_id;
          this.vekalet.varsayilan_banka_hesabi_sahibi = this.bankaHesaplari[0].varsayilan_banka_hesabi_sahibi;
          this.selected.push(this.bankaHesaplari[0]);
          this.$http
              .put('/api/v1/vekalet-detay-list/' + this.vekalet.vekalet_bilgileri.id, this.vekalet)
              .then(() => this.$emit("load"));
        }
      } else {
        const selectedAccount = this.bankaHesaplari.find(
            (account:any) => account.banka_hesap_id === this.vekalet.varsayilan_banka_hesabi.banka_hesap_id
        );
        if (selectedAccount) {
          this.selected.push(selectedAccount);
        }
      }
    }
  }

  @Watch("vekalet.muvekkiller.length")
  onMuvekkilChange() {
    this.bankaHesaplariDoldur();
  }

  @Watch("vekalet.avukatlar.length")
  onAvukatChange() {
    this.bankaHesaplariDoldur();
  }

  handleCheckboxInput(event: any, select: Function, item: any) {
    select(event);
    // select fonksiyonu çağrıldıktan sonra onselectedChange metodunu çağır
    this.$nextTick(() => {
      this.onselectedChange({ value: event, item: item });
    });
  }

  onselectedChange(val: any) {
    let vekalet: any;

    if (val.value) {
      // Checkbox işaretlendiğinde
      this.selected = [val.item];

      this.vekalet.varsayilan_banka_hesabi = val.item;
      this.vekalet.varsayilan_banka_hesabi.banka_hesap_id = val.item.banka_hesap_id;
      this.vekalet.varsayilan_banka_hesabi_sahibi = val.item.varsayilan_banka_hesabi_sahibi;

      vekalet = {
        'vekalet_no': this.vekalet.vekalet_bilgileri.vekalet_no,
        'varsayilan_banka_hesabi_id': val.item.banka_hesap_id,
        'varsayilan_banka_hesabi_sahibi': val.item.varsayilan_banka_hesabi_sahibi
      };
    } else {
      // Checkbox işareti kaldırıldığında
      this.selected = [];

      this.vekalet.varsayilan_banka_hesabi = null;
      this.vekalet.varsayilan_banka_hesabi_sahibi = null;

      vekalet = {
        'vekalet_no': this.vekalet.vekalet_bilgileri.vekalet_no,
        'varsayilan_banka_hesabi_id': null,
        'varsayilan_banka_hesabi_sahibi': null
      };
    }

    this.$http
        .put('/api/v1/vekalet/' + this.vekalet.vekalet_bilgileri.id, vekalet)
        .then(()=>{
          this.$emit('hesapSelected')
          this.load()
    })
        .catch(error => {
          console.error("Error updating vekalet:", error);
        });
}

  load() {
    this.$emit("load");
  }

  refreshBankaHesaplari() {
    if (!this.vekalet?.vekalet_bilgileri?.id) return;
    
    this.$http
      .get('/api/v1/vekalet-detay-list/' + this.vekalet.vekalet_bilgileri.id)
      .then((response: any) => {
        const data = response.data?.data || response.data;
        
        // Vekalet verisini güncelle
        if (data.avukatlar) {
          this.vekalet.avukatlar = data.avukatlar;
        }
        if (data.muvekkiller) {
          this.vekalet.muvekkiller = data.muvekkiller;
        }
        
        // Banka hesaplarını yeniden doldur
        this.bankaHesaplariDoldur();
      })
      .catch((error: any) => {
        console.error("Error refreshing bank accounts:", error);
      });
  }

  mounted() {
    this.bankaHesaplariDoldur();
    if (this.vekalet && this.vekalet.varsayilan_banka_hesabi && this.bankaHesaplari.length > 0) {
      // Find the corresponding bank account in the list
      const selectedAccount = this.bankaHesaplari.find(
          account => account.banka_hesap_id === this.vekalet.varsayilan_banka_hesabi.banka_hesap_id
      );

      if (selectedAccount) {
        this.selected = [selectedAccount];
      }
    }
  }


  // IBAN geçerliliğini kontrol eden yardımcı metod
  isValidIBAN(iban: string): boolean {
    // Boş veya undefined IBAN kontrolü
    if (!iban) return false;
    
    // IBAN formatı kontrolü (basit kontrol - gerçek bir IBAN validasyonu daha karmaşık olabilir)
    return iban.length >= 5 && iban.trim() !== "";
  }

  // Listeye eklenecek hesabın zaten mevcut olup olmadığını kontrol eder
  isBankaHesabiExists(newAccount: any): boolean {
    // IBAN veya hesap numarası ile kontrol
    return this.bankaHesaplari.some(account => 
      (account.iban && newAccount.iban && account.iban === newAccount.iban) || 
      (account.banka_hesap_id && newAccount.banka_hesap_id && account.banka_hesap_id === newAccount.banka_hesap_id)
    );
  }

  bankaHesaplariDoldur() {
    this.bankaHesaplari = [];
    this.burolar = [];
    
    // Avukat banka hesaplarını ekle
    if (this.vekalet?.avukatlar && Array.isArray(this.vekalet.avukatlar)) {
      for (let i = 0; i < this.vekalet.avukatlar.length; i++) {
        let avukat: AvukatEntity = this.vekalet.avukatlar[i];
        
        if (avukat?.id) {
          this.buroBankaHesabiGetir(avukat.id);
        }
        
        if (avukat?.banka_hesaplari && Array.isArray(avukat.banka_hesaplari)) {
          avukat.banka_hesaplari.forEach((bankaHesabi: any) => {
            // Geçerli IBAN kontrolü
            if (bankaHesabi && this.isValidIBAN(bankaHesabi.iban) && !this.isBankaHesabiExists(bankaHesabi)) {
              bankaHesabi.varsayilan_banka_hesabi_sahibi = BankaHesabiSahibi.vekil;
              this.bankaHesaplari.push(bankaHesabi);
            }
          });
        }
      }
    }

    // Müvekkil banka hesaplarını ekle
    if (this.vekalet?.muvekkiller && Array.isArray(this.vekalet.muvekkiller)) {
      for (let i = 0; i < this.vekalet.muvekkiller.length; i++) {
        let kisiKurum: KisiEntity | KurumEntity = this.vekalet.muvekkiller[i].kisi ?? this.vekalet.muvekkiller[i].kurum;
        
        if (kisiKurum?.banka_hesaplari && Array.isArray(kisiKurum.banka_hesaplari)) {
          kisiKurum.banka_hesaplari.forEach((bankaHesabi: any) => {
            // Geçerli IBAN kontrolü
            if (bankaHesabi && this.isValidIBAN(bankaHesabi.iban) && !this.isBankaHesabiExists(bankaHesabi)) {
              bankaHesabi.varsayilan_banka_hesabi_sahibi = BankaHesabiSahibi.muvekkil;
              this.bankaHesaplari.push(bankaHesabi);
            }
          });
        }
      }
    }
  }

  buroBankaHesabiGetir(deger: number) {
    this.$http
        .get("/api/v1/personel/" + deger + "/buro")
        .then((response) => {
          let buro: BuroEntity = response.data
          if (buro && !this.burolar.includes(buro.id)) {
            this.burolar.push(buro.id);
            
            if (buro.banka_hesaplari) {
              buro.banka_hesaplari.forEach((bankaHesabi: any) => {
                // Geçerli IBAN kontrolü ve mükerrer kontrol
                if (bankaHesabi && this.isValidIBAN(bankaHesabi.iban) && !this.isBankaHesabiExists(bankaHesabi)) {
                  bankaHesabi.varsayilan_banka_hesabi_sahibi = BankaHesabiSahibi.vekil;
                  this.bankaHesaplari.push(bankaHesabi);
                }
              });
            }
          }
        });
  }
}
